import { useQuery } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import type { ClientApiFeatureSubPathParams } from "@visioni/a3s-client-api";
import type { SnapshotHistoryItem, ListSnapshotHistoryQueryParams } from "../../client-messages/snapshot-history";
import { snapshotHistoryQuery } from "../queries";

export type UseSnapshotHistoryOptions = ClientApiFeatureSubPathParams &
  ListSnapshotHistoryQueryParams & {
    enabled?: boolean;
  };

export function useSnapshotHistory(options: UseSnapshotHistoryOptions) {
  const apiConfig = useApiConfig();
  const { enabled = true, startTime, endTime, ...pathParams } = options;

  const queryParams = { startTime, endTime };

  return useQuery({
    ...snapshotHistoryQuery(apiConfig, pathParams, queryParams),
    enabled,
    select: (response): SnapshotHistoryItem[] => response.data,
    refetchOnMount: "always",
  });
}
